// SKYCORE MAP.NAV.3 — contrat PUR de la popup drone (aucun DOM/Leaflet) : une seule popup principale,
// ouverture/fermeture déterministes, positionnement borné au cadre visible (rotation comprise).
import { rotateVec } from "@/lib/mapRotation";

// État : { openId, seq }. `seq` identifie UNE ouverture (nouvelle instance Leaflet) ; une mise à jour de
// télémétrie ne change jamais seq (aucune destruction/recréation de la popup).
export const POPUP_CLOSED = Object.freeze({ openId: null, seq: 0 });

export function popupReducer(s, a) {
  switch (a.type) {
    // Clic marqueur : ouvre, transfère, ou conserve (2e clic sur le même drone = reste ouverte).
    case "SELECT": return s.openId === a.id ? s : { openId: a.id, seq: s.seq + 1 };
    // Fermeture (bouton, clic carte, Échap, autre popup). seq fourni : ignorée si elle vise une ancienne ouverture.
    case "CLOSE": return s.openId == null || (a.seq != null && a.seq !== s.seq) ? s : { openId: null, seq: s.seq };
    // Disparition effective du drone (absent de la liste) : fermeture.
    case "PRESENCE": return s.openId != null && !a.ids.includes(s.openId) ? { openId: null, seq: s.seq } : s;
    // Sélection modifiée hors carte (liste, autre composant) vers un AUTRE drone : fermeture.
    case "EXTERNAL_SELECT": return s.openId != null && a.id != null && a.id !== s.openId ? { openId: null, seq: s.seq } : s;
    default: return s;
  }
}

// Marges internes du cadre visible (px écran). À droite : colonne nord/zoom quand la carte tourne.
export function popupPadding(rotating) {
  return { t: 12, r: rotating ? 52 : 12, b: 20, l: 12 };
}

// Dimensions maximales selon le cadre visible (PC / tablette / mobile / mini-carte). En SUIVRE, le
// drone est au centre : la popup dispose de la moitié supérieure seulement.
export function popupLimits(w, h, following) {
  // Largeur du CONTENU : cadre − marges internes popup (~26 px) − marges de cadre (24 px).
  const maxWidth = Math.max(90, Math.min(300, Math.floor(w) - 50));
  const minWidth = Math.min(170, maxWidth);
  const maxHeight = Math.max(110, Math.floor(following ? h / 2 - 60 : h - 80));
  return { maxWidth, minWidth, maxHeight };
}

// Décalage ÉCRAN (sx, sy) qui ramène le rectangle `r` dans le cadre `f` (marges `pad`). L'en-tête (haut
// / gauche) est prioritaire si la popup est plus grande que le cadre. 0 si déjà visible.
export function overflowShift(r, f, pad) {
  const minX = f.left + pad.l, maxX = f.right - pad.r, minY = f.top + pad.t, maxY = f.bottom - pad.b;
  let sx = 0, sy = 0;
  if (r.right > maxX) sx = maxX - r.right;
  if (r.left + sx < minX) sx = minX - r.left;
  if (r.bottom > maxY) sy = maxY - r.bottom;
  if (r.top + sy < minY) sy = minY - r.top;
  return [Math.round(sx), Math.round(sy)];
}

// Décalage écran souhaité du contenu -> argument de map.panBy() dans le repère Leaflet (non tourné).
export function screenShiftToPan(sx, sy, bearing) {
  const [x, y] = rotateVec(-sx, -sy, bearing || 0);
  return [Math.round(x) || 0, Math.round(y) || 0];
}
